const useDevice = () => {
	const devicesList: string[] = ["iPhone", "Android", "Huawei"];
	const deviceName = computed(() => {
		const currentDeviceName: string | undefined = devicesList.find((device) => navigator.userAgent.toString().indexOf(device) > -1);
		return currentDeviceName ? currentDeviceName : "Desktop";
	});

	const isIOS = computed(() => deviceName.value === "iPhone");
	const isAndroid = computed(() => deviceName.value === "Android");
	const isHuawei = computed(() => deviceName.value === "Huawei");

	return { deviceName, isIOS, isAndroid, isHuawei };
};

export default useDevice;
